<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="3">
              <!-- 店舗：Adminは全店舗、ゾーンマネージャーは担当店舗から複数選択、店舗ユーザーは自店舗に固定（入荷予定一覧と同じ） -->
              <v-select density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.siteCodeList"
                :items="siteCodeList" item-title="code_name" item-value="code" :label="$t('soldoutDp.label.siteCode')"
                multiple :disabled="siteFixed" :error-messages="siteError">
                <template v-slot:prepend-item>
                  <v-list-item :title="$t('soldoutDp.label.selectAll')" @click="toggleAllSites">
                    <template v-slot:prepend>
                      <v-checkbox-btn :model-value="isAllSiteSelected" :indeterminate="isSomeSiteSelected" :ripple="false" />
                    </template>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <!-- 複数選択時は1件目のみ表示し、残りは「他n件」にまとめる -->
                <template v-slot:selection="{ item, index }">
                  <div v-if="index === 0" class="soldout-site-selection">
                    <span v-if="isAllSiteSelected && siteCodeList.length > 1">
                      {{ $t('soldoutDp.label.siteAll', [siteCodeList.length]) }}
                    </span>
                    <template v-else>
                      <v-chip size="small" label class="soldout-site-chip">{{ item.title }}</v-chip>
                      <span v-if="searchCondition.siteCodeList.length > 1" class="text-caption ml-2 text-no-wrap">
                        {{ $t('soldoutDp.label.siteOthers', [searchCondition.siteCodeList.length - 1]) }}
                      </span>
                    </template>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.janCode"
                :label="$t('soldoutDp.label.janCode')" />
            </v-col>
            <v-col cols="3">
              <DatePicker ref="soldoutDateFrom" v-model="searchCondition.soldoutDateFrom" :label="$t('soldoutDp.label.soldoutDateFrom')"></DatePicker>
            </v-col>
            <v-col cols="3">
              <DatePicker ref="soldoutDateTo" v-model="searchCondition.soldoutDateTo" :label="$t('soldoutDp.label.soldoutDateTo')"></DatePicker>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn text @click="clear">{{ $t('common.action.clear') }}</v-btn>
              <v-btn theme="dark" class="ml-4 px-8 bg-grey-darken-3" elevation="2" @click="search"
                :loading="isSearching">{{ $t('common.action.search') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <th v-for="header in headers" :key="header" @click.stop="tableSort(header)"
                      :style="cursorCheck(header)">{{ $t("soldoutDp.label.table." + header) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in filteredDataList" :key="index">
                    <template v-for="header in headers" :key="header">
                      <td>{{ data[header] }}</td>
                    </template>
                  </tr>
                  <tr>
                    <td :colspan="headers.length">
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-pagination v-model="currentPageNo" :length="maxPageNo" />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select density="compact" variant="outlined" hide-details="auto" v-model="displayPerPage"
                    :items="displayPerPageItem" item-title="name" item-value="value" :label="$t('common.label.displayCountPerPage')"
                    @update:modelValue="resetCondition()" return-object />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  {{ displayContentNo.minNo }} - {{ displayContentNo.maxNo }}{{ $t('common.label.displayedDataRange') }} / {{ dataList.length }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn dark class="px-8 bg-indigo-darken-1" elevation="2" @click.prevent="downloadCsv"
                :disabled="dataList.length == 0" :loading="isDownloading">{{ $t('common.action.outputCsv')}}</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog" />
        <MessageDialog v-if="commonMsgDlgVisible" :dialog-data="dataForMsgDialog" :handle-ok="closeMessageDataDialog" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import DatePicker from "@/components/DatePicker";
import api from "@/apis/staff";
import store from "@/store";
import utils from "@/utils";
import constant from "@/utils/constant";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import MessageDialog from "@/components/dialog/MessageDialog";

export default {
  components: { AppWrapperView, DatePicker, ZeroData, MessageDialog },
  props: {},


  computed: {

    // ページング情報の返却
    displayContentNo() {
      const minNo = this.dataList.length != 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
      const maxNo = this.displayPerPage.value * (this.currentPageNo);
      if (maxNo > this.dataList.length || this.displayPerPage.value == 0) {
        return { minNo: minNo, maxNo: this.dataList.length };
      }
      return { minNo: minNo, maxNo: maxNo };
    },

    // 最大ページ
    maxPageNo() {
      if (this.displayPerPage.value == 0) return 0;
      return Math.ceil(this.dataList.length / this.displayPerPage.value);
    },

    // ソート
    sortedTable() {
      let tempArray = this.dataList.map(x => x);
      if (this.sortState.target != "") {
        tempArray = tempArray.sort(this.defaultSorter(this.sortState.ascent));
      }
      return tempArray;
    },
    filteredDataList() {
      const tempArray = this.sortedTable;
      return tempArray.slice(this.displayContentNo.minNo - 1, this.displayContentNo.maxNo);
    },
    // ヘッダー
    headers() {
      return this.$getTableDef("SoldoutDpPage");
    },

    // 店舗：全選択状態（「すべて選択」のチェック状態）
    isAllSiteSelected() {
      return this.siteCodeList.length > 0 && this.searchCondition.siteCodeList.length == this.siteCodeList.length;
    },
    // 店舗：一部選択状態（「すべて選択」の中間状態）
    isSomeSiteSelected() {
      return this.searchCondition.siteCodeList.length > 0 && !this.isAllSiteSelected;
    },
  },

  watch: {
    // 店舗を選択し直したら、未選択エラーは消す
    'searchCondition.siteCodeList'(list) {
      if (list && list.length > 0) this.siteError = "";
    },
  },


  data: () => ({
    currentPageNo: 1,
    // 1ページ表示数
    displayPerPage: {},
    displayPerPageItem: [],
    // ソートの状態
    sortState: { target: "", ascent: true },
    siteCodeList: [],
    // 店舗を自店舗に固定する（店舗ユーザー）
    siteFixed: false,
    // 店舗の未選択エラー（Admin／ゾーンマネージャーが全解除して検索した場合）
    siteError: "",
    dataList: [],

    // 検索条件
    searchCondition: {
      siteCodeList: [],    // 店舗コード（複数選択）
      janCode: "",
      soldoutDateFrom: "",
      soldoutDateTo: "",
    },
    // 一覧表示中データの検索条件（CSV出力に使用）
    searchedRequest: null,
    // 0件取得時の警告ダイアログ
    zeroDataWarningDialogFlg: false,
    // 検索中
    isSearching: false,
    // CSV出力中
    isDownloading: false,
    // メッセージダイアログ
    commonMsgDlgVisible: false,
    dataForMsgDialog: {},
  }),


  methods: {
    // 汎用的なソート関数を返却する
    defaultSorter(isAscent) {
      return (a, b) => {
        const multiplier = isAscent ? 1 : -1;
        if (a[this.sortState.target] > b[this.sortState.target]) return 1 * multiplier;
        if (a[this.sortState.target] < b[this.sortState.target]) return -1 * multiplier;
        return 0;
      }
    },
    // カーソル表示形式を変更
    cursorCheck(value) {
      return "cursor: pointer;"
    },

    // 店舗検索リスト取得
    // Admin：全店舗から複数選択 / ゾーンマネージャー：担当店舗から複数選択（いずれも初期値は全選択）
    // 店舗ユーザー：自店舗のみ（全選択で固定）。Admin以外はサーバ側でも自店舗の範囲に限定する
    getValidShopSearchList() {
      const role = store.getRole();
      const isAdmin = role == constant.ROLE.ADMIN.id;
      this.siteFixed = !isAdmin && role != constant.ROLE.ZONE_MANAGER.id;
      // selectSiteFlag：0：他店舗含む / 1：自店舗のみ
      api.post("/store/search/minimal", { selectSiteFlag: isAdmin ? 0 : 1 })
        .then((response) => {
          if (response.status == 1) return;
          response.data.results?.shopList.forEach(element => {
            this.siteCodeList.push({
              name: element.name,
              code: element.code,
              code_name: element.code + '_' + element.name
            })
          })
          this.searchCondition.siteCodeList = this.defaultSiteCodeList();
        })
        .catch((error) => {
          //do nothing
        })
    },

    // 店舗の初期値：全店舗を選択
    defaultSiteCodeList() {
      return this.siteCodeList.map(e => e.code);
    },

    // 店舗「すべて選択」：全選択済みなら全解除、それ以外は全選択
    toggleAllSites() {
      this.searchCondition.siteCodeList = this.isAllSiteSelected ? [] : this.defaultSiteCodeList();
    },

    // テーブルの条件リセット
    resetCondition() {
      this.currentPageNo = 1;
      this.sortState.target = "";
      this.sortState.ascent = true;
    },
    tableSort(headValue) {
      this.currentPageNo = 1;
      if (this.sortState.target == headValue) {
        this.sortState.ascent = !this.sortState.ascent;
      } else {
        this.sortState.target = headValue;
        this.sortState.ascent = true;
      }
    },

    clear() {
      this.$refs.soldoutDateFrom.clear()
      this.$refs.soldoutDateTo.clear()
      this.siteError = "";
      this.searchCondition = {
        siteCodeList: this.defaultSiteCodeList(),
        janCode: "",
        soldoutDateFrom: "",
        soldoutDateTo: "",
      }
    },

    closeZeroDataDialog() {
      this.zeroDataWarningDialogFlg = false;
    },

    closeMessageDataDialog() {
      this.commonMsgDlgVisible = false;
    },

    // 画面の検索条件からリクエストを生成
    createRequest() {
      return {
        // 全選択（空配列）の場合は店舗で絞り込まない（店舗マスタ未登録の店舗も対象にするため）
        // Admin以外はAPI側で自店舗（ゾーンマネージャーは担当店舗）に限定される
        siteCodeList: this.isAllSiteSelected ? [] : (this.searchCondition.siteCodeList ?? []),
        janCode: this.searchCondition.janCode,
        soldoutDateFrom: this.searchCondition.soldoutDateFrom?.replaceAll("-", "") ?? "",
        soldoutDateTo: this.searchCondition.soldoutDateTo?.replaceAll("-", "") ?? "",
      };
    },

    search() {
      // Admin／ゾーンマネージャーが店舗をすべて解除した場合は検索しない
      // （全選択と同じ空配列を送ると全店舗が対象になってしまうため）
      if (!this.siteFixed && (this.searchCondition.siteCodeList ?? []).length == 0) {
        this.siteError = this.$t('soldoutDp.message.siteRequired');
        return;
      }
      this.siteError = "";
      this.isSearching = true;
      const request = this.createRequest();
      api.post("/soldout-dp/search", request).then((response) => {
        this.dataList = response.data.results?.soldoutDpList ?? [];
        this.searchedRequest = request;
        this.resetCondition();
        // 0件ダイアログ処理
        if (this.dataList.length == 0) this.zeroDataWarningDialogFlg = true;
        this.isSearching = false;
      }).catch((error) => {
        this.dataList = [];
        this.zeroDataWarningDialogFlg = true;
        this.isSearching = false;
      });
    },

    // ダウンロードファイル名：サーバが付与したファイル名（CSV内の _登録日付/_登録時刻 と同じ日時）を使用する。
    // 取得できない場合のみ画面側で生成する。
    getDownloadFileName(contentDisposition) {
      const matched = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition ?? "");
      if (matched) return decodeURIComponent(matched[1]);
      return `${this.$t('soldoutDp.fileNamePrefix.csv')}${utils.csvTimeStamp(new Date())}.csv`;
    },

    // CSVダウンロード処理（「売切DPデータ取得」形式のファイルをサーバで生成）
    downloadCsv() {
      if (!this.searchedRequest) return;
      this.isDownloading = true;
      api.postWithConfig("/soldout-dp/csv/download", this.searchedRequest, { responseType: 'blob' })
        .then(async response => {
          // 失敗時はJSONでエラー内容が返却される
          if (response.data.type == "application/json") {
            const errText = await response.data.text();
            const json = JSON.parse(errText);
            this.dataForMsgDialog = { message: json.errorMessage };
            this.commonMsgDlgVisible = true;
            this.isDownloading = false;
            return;
          }

          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = this.getDownloadFileName(response.headers['content-disposition']);
          link.click();
          URL.revokeObjectURL(url);
          this.isDownloading = false;
        })
        .catch((error) => {
          this.isDownloading = false;
          this.dataForMsgDialog = { message: this.$t('common.message.unknownError') };
          this.commonMsgDlgVisible = true;
        });
    },
  },
  created() {
    this.getValidShopSearchList()
  },
  mounted() {
    this.displayPerPage = utils.getDisplayPerPage(this.$t)
    this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);
  }
};
</script>

<style>
/* 店舗の選択表示（1件目＋「他n件」）：枠内に収める */
.soldout-site-selection {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}
.soldout-site-chip.v-chip.v-chip--size-small {
  min-width: 0;
  margin: 0;
  height: 22px;
}
.soldout-site-chip .v-chip__content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
